import ActionIconGroup from "../../../../ActionIconGroup";
import { useChatListActionsBar } from "../../../../hooks/useChatListActionsBar";
import useCustomChatListAction from "../../../../hooks/useCustomChatListAction";
import { memo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var ErrorActionsBar = /*#__PURE__*/memo(function (_ref) {
  var text = _ref.text,
    onActionClick = _ref.onActionClick,
    actionsProps = _ref.actionsProps;
  var _useChatListActionsBa = useChatListActionsBar(text),
    regenerate = _useChatListActionsBa.regenerate,
    del = _useChatListActionsBa.del;
  var _useCustomChatListAct = useCustomChatListAction({
      dropdownMenu: [],
      items: [regenerate, del],
      actionsProps: actionsProps
    }),
    items = _useCustomChatListAct.items;
  return /*#__PURE__*/_jsx(ActionIconGroup, {
    items: items,
    onActionClick: onActionClick,
    type: "ghost"
  });
});